import { FeelgoodOne } from '@icon-park/react';
import classNames from 'classnames';
import { useRef, useEffect, useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { IQuestionnaireProps } from '../questionnaire/questionnaire';
import ComponentStore from '../../store';
import styles from './style.module.less';
import '../../feelgood.less';
import './index.less';

const Entry: React.FC<IQuestionnaireProps> = props => {
  const {
    mode = 'light',
    theme,
    style = {},
    entryUrl,
    device,
    defaultTextMap,
    onEntryClick,
    onEntryShow,
    isAutoPopup,
    openSurveyInNewTab,
    preview,
    independentEntryTime = 3000,
  } = props;
  const [showTip, setShowTip] = useState<boolean | undefined>();
  const { getCurrentDevice, setThemeData, defaultText, setDefaultText } =
    ComponentStore.useContext();
  useEffect(() => {
    setDefaultText(defaultTextMap);
  }, [defaultTextMap]);
  const feelgoodRef = useRef<HTMLDivElement>(null);
  const entryTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if ((isAutoPopup && !openSurveyInNewTab) || preview) {
      setShowTip(true);
      entryTimeoutRef.current = setTimeout(() => {
        setShowTip(false);
      }, independentEntryTime);
    }
    return () => {
      clearTimeout(entryTimeoutRef.current);
    };
  }, [independentEntryTime, isAutoPopup, preview]);
  useEffect(() => {
    if (theme && mode && feelgoodRef.current) {
      setThemeData(theme, mode, getCurrentDevice(device), feelgoodRef.current);
    }
  }, [theme, mode, device, feelgoodRef]);

  useEffect(() => {
    onEntryShow?.();
  }, [onEntryShow]);
  const timeoutId = useRef<ReturnType<typeof setTimeout>>();
  return (
    <div
      className={classNames(
        'feelgood',
        `feelgood__theme--${mode}`,
        `feelgood__device--${getCurrentDevice(device)}`,
        styles[`questionnaire__widgets-${getCurrentDevice(device)}`],
      )}
      id="feelgood-questionnaire-widgets"
      ref={feelgoodRef}
      style={{
        visibility: 'hidden',
        left: style?.left,
        top: style?.top,
        right: style?.right,
        bottom: style?.bottom,
        zIndex: style?.zIndex,
        flexDirection: style?.popDirection === 'right' ? 'row-reverse' : 'row',
      }}
      onClick={() => {
        onEntryClick?.();
      }}
    >
      <div
        data-tooltip-id="my-tooltip"
        className={classNames(
          styles.questionnaire__entry,
          styles.entry,
          'feelgood-widgets_entry',
        )}
        onMouseEnter={() => {
          timeoutId.current = setTimeout(() => {
            setShowTip(true);
          }, 300);
        }}
        onMouseLeave={() => {
          clearTimeout(timeoutId.current);
          setShowTip(false);
        }}
        style={{
          backgroundColor: entryUrl ? 'transparent' : '',
          boxShadow: entryUrl ? 'unset' : '',
        }}
      >
        {entryUrl ? (
          <img
            src={entryUrl}
            className={styles.customImg}
            alt=""
            onError={() => {
              console.warn('img error');
            }}
          />
        ) : (
          <FeelgoodOne theme="outline" size="24" fill="#ffffff" />
        )}
      </div>
      <ReactTooltip
        isOpen={showTip}
        id="my-tooltip"
        place="left"
        content={
          defaultText.go_to_independent_page ||
          'Go to a independent page to complete the survey'
        }
      />
    </div>
  );
};

export default function EntryMain(prop: IQuestionnaireProps) {
  return (
    <ComponentStore.Provider>
      <Entry {...prop} />
    </ComponentStore.Provider>
  );
}
